import { useEffect, useState } from 'react';
import './ExamplesGenerator.scss';
import { Button, Icon, Popup } from 'semantic-ui-react';

function TextLoader() {
    const [countElipses, setCountElipses] = useState(0);
    useEffect(() => {
        const timerId = setInterval(() => {
            setCountElipses(countElipses => countElipses === 5 ? 0 : countElipses + 1);
        }, 300);
        return () => clearInterval(timerId);
    }, []);
    let result = '';
    for (let i = 0; i < countElipses; i++) {
        result += '.';
    }
    return <span>{result}</span>
}

interface ExamplesGeneratorProps<T>{
    context:any
    target:string
    apiMethod:(context:any)=>Promise<T[]>
    toTextDisplay?:(item:T)=>string
    toPopupDisplay?:(item:T)=>string
    onSelect:(item:T)=>void
    popupDescription:string
}

function ExamplesGenerator<T>({target, context, apiMethod, toTextDisplay = (x:T) => (x as string), toPopupDisplay = undefined, onSelect, popupDescription}:ExamplesGeneratorProps<T>) {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isNotStarted, setIsNotStarted] = useState(true);
    const [examples, setExamples] = useState<T[]>([]);

    const load = () => {
        setIsNotStarted(false);
        setIsLoading(true);
        setIsError(false);
        apiMethod(context).then(resp => {
            setIsLoading(false);
            setExamples(resp)
        }).catch(e => {
            setIsLoading(false);
            setIsError(true);
        })        
    };

    const renderItem = (item:T) => {
        const aElement = <a href="/" onClick={e => {
            e.stopPropagation(); 
            e.preventDefault();
            onSelect(item);
            return false;
        }}>{toTextDisplay(item)}</a>;
        if(toPopupDisplay) {
            return <Popup basic inverted content={toPopupDisplay(item)} trigger={aElement} />;
        }
        return aElement;
    };
    if(target !== '')
        return <></>;
    return <div className='examples-generator-container'>
        {isNotStarted ? <Popup mouseEnterDelay={1000} basic inverted content={<div>{popupDescription}<hr/><div>Будет потрачено ~ <b>452</b> токенов</div></div>} trigger={<Button onClick={load} size='tiny' icon basic><Icon name='magic' /> Придумать примеры</Button> }/>: <>
            {isError ? <div>Не получилось придумать примеры... <Button onClick={load} size='tiny' icon basic><Icon name='refresh' /> Попробовать ещё раз</Button></div> : <>
                {isLoading ? <>Придумываю примеры<TextLoader /></> : <>
                    Например: {examples.map((example, index) => <>{renderItem(example)}{index < examples.length - 1 && ', '}</>)}. <Button onClick={load} size='tiny' icon basic><Icon name='refresh' /> Придумать другие</Button>
                </>}
            </>}
        </>}
    </div>;
}

export default ExamplesGenerator;